import APIService from "@/services/APIService.js";

export default {
  getImportacoes() {
    return APIService.apiCall().get(`/importacoesBdgdV2/getImportacoes`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/importacoesBdgdV2/salvar`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/importacoesBdgdV2/excluir/${id}`);
  },
};
